import { Form, Formik } from "formik";
import { useState } from "react";
import { object, string } from "yup";
import Radio from "../UI/Radio";
import TextArea from "../UI/TextArea";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import Callout from "../UI/Callout";
import { handleAPIError } from "../../utils/index.jsx";
import styles from "./UnsubscribeModal.module.css";

const MOTIFS = [
  { key: "trop_cher", label: "C'est trop cher pour moi" },
  { key: "plus_de_biens", label: "Je n'ai plus de biens à gérer" },
  {
    key: "fonctionnalites_manquantes",
    label: "Il manque des fonctionnalités dont j'ai besoin",
  },
  { key: "trop_complique", label: "L'outil est trop compliqué à utiliser" },
  { key: "concurrent", label: "J'utilise un autre outil" },
  { key: "pas_assez_utilise", label: "Je n'utilise pas assez l'outil" },
  {
    key: "problemes_techniques",
    label: "J'ai rencontré trop de bugs/problèmes",
  },
  { key: "autre", label: "Autre raison" },
];

const validationSchema = object({
  motif: string().required("Veuillez sélectionner une raison"),
  motif_explained: string(),
});

export default function UnsubscribeModal({ onSubmit }) {
  const [error, setError] = useState();

  async function submitHandler(values) {
    setError("");
    try {
      await onSubmit(values);
    } catch (e) {
      setError(handleAPIError(e));
    }
  }

  return (
    <Formik
      initialValues={{ motif: "", motif_explained: "" }}
      validationSchema={validationSchema}
      onSubmit={submitHandler}
    >
      <Form className={styles.form}>
        <p className={"primaryText"}>
          Pourquoi souhaitez-vous vous désabonner ?
        </p>
        {MOTIFS.map((m) => (
          <div key={m.key}>
            <Radio name="motif" value={m.key} label={m.label} />
          </div>
        ))}
        <TextArea
          name="motif_explained"
          label="Précisez votre raison"
          marginForm=""
        />
        <div className={"text-right"}>
          <FormikSubmitButton buttonStyle="secondaryDelete">
            Confirmer l'annulation
          </FormikSubmitButton>
        </div>
        <Callout variant="danger">{error}</Callout>
      </Form>
    </Formik>
  );
}
